import HiggsPromise from '../utils/higgsPromise';
import { ContentType } from '../constants/enum';

// 文件上传
export function fileUpload() {
    return HiggsPromise({
        timeout: 20000,
        url: '/csrc/reportsearch/v1.0/report/fileupload',
        contentType: ContentType.FILE
    });
}

// 生成报告
export function generateReport(data) {
    return HiggsPromise({
        timeout: 60000,
        url: '/csrc/reportsearch/v1.0/report/generate',
        data: data
    });
}

// 报告list
export function getReportList(data) {
    return HiggsPromise({
        url: '/csrc/reportsearch/v1.0/report/list',
        data: data
    });
}

// 下载报告
export function downloadReport(data) {
    return HiggsPromise({
        url: '/csrc/reportsearch/v1.0/report/download',
        contentType: ContentType.FILE,
        data: data
    });
}

// 数据模板下载
export function downloadTemplate() {
    return HiggsPromise({
        url: '/csrc/reportsearch/v1.0/template/download',
        contentType: ContentType.FILE
    });
}

// 本地数据财务分析生成报告
export function generateLocalReport(data) {
    return HiggsPromise({
        timeout: 600000,
        url: '/csrc/reportsearch/v1.0/report/generate/local',
        data: data
    });
}



// WEBPACK FOOTER //
// ./src/services/report.js